import { headerAcceptLanguage } from '@/helpers/functions';
import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		faqs: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/faqs').then(({ data }) => {
				commit(types.STORE_FAQS, data);
				return data;
			})
		},

		fetchById({ commit }, { id, acceptLanguage }) {
			const configs = headerAcceptLanguage(acceptLanguage);
			return axios.get(`/faqs/${id}`, configs).then(({ data }) => {
				return data;
			})
		},

		create({ commit }, { question, answer, productId, newsId, acceptLanguage }) {
			const configs = headerAcceptLanguage(acceptLanguage);
			return axios.post('/faqs', { question, answer, productId, newsId }, configs).then(({ data }) => data);
		},

		update({ commit }, { id, question, answer, productId, newsId, acceptLanguage }) {
			const configs = headerAcceptLanguage(acceptLanguage);
			return axios.post(`/faqs/${id}`, { question, answer, productId, newsId, _method: 'PUT' }, configs).then(({ data }) => data);
		},

		delete({ commit }, { id }) {
			return axios.post(`/faqs/${id}`, { _method: 'DELETE' });
		},
	},

	mutations: {
		[types.STORE_FAQS](state, faqs) {
			state.faqs = faqs;
		}
	},

	getters: {
		getFAQById: state => id => state.faqs.find(c => c.id === id),
	}
}